import { render, staticRenderFns } from "./ElectionsVoteList.vue?vue&type=template&id=793ef91b"
import script from "./ElectionsVoteList.vue?vue&type=script&lang=js"
export * from "./ElectionsVoteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports